import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router, Switch, Route, Redirect } from 'react-router-dom';
import { ThemeProvider, createTheme } from '@material-ui/core/styles';
import CssBaseline from '@material-ui/core/CssBaseline';
import { ApiKeyProvider } from './context/ApiKeyContext';
import LoginPage from './components/LoginPage';
import MainLayout from './layouts/MainLayout';
import EditorTemplates from './pages/EditorTemplates';
import Contestacao from './pages/Contestacao';
import './App.css';

const theme = createTheme({
  palette: {
    primary: {
      main: '#f44336',
    },
    secondary: {
      main: '#3f51b5',
    },
    background: {
      default: '#f5f5f5',
    },
  },
  typography: {
    fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
  },
});

function App() {
  const [isAuthenticated, setIsAuthenticated] = useState(false);

  // Verificar se existe uma API Key salva no localStorage
  useEffect(() => {
    const apiKey = localStorage.getItem('ikaro_api_key');
    if (apiKey) {
      setIsAuthenticated(true);
    }
  }, []);

  // Componente para rotas protegidas que requerem autenticação
  const PrivateRoute = ({ children, ...rest }) => {
    return (
      <Route
        {...rest}
        render={({ location }) =>
          isAuthenticated ? (
            children
          ) : (
            <Redirect
              to={{
                pathname: "/login",
                state: { from: location }
              }}
            />
          )
        }
      />
    );
  };

  return (
    <ApiKeyProvider>
      <ThemeProvider theme={theme}>
        <CssBaseline />
        <Router>
          <div className="App">
            <Switch>
              <Route path="/login">
                {isAuthenticated ? (
                  <Redirect to="/editor-templates" />
                ) : (
                  <LoginPage onLoginSuccess={() => setIsAuthenticated(true)} />
                )}
              </Route>
              
              <PrivateRoute path="/editor-templates">
                <MainLayout 
                  isAuthenticated={isAuthenticated}
                  setIsAuthenticated={setIsAuthenticated}
                >
                  <EditorTemplates />
                </MainLayout>
              </PrivateRoute>
              
              <PrivateRoute path="/contestacao">
                <MainLayout 
                  isAuthenticated={isAuthenticated}
                  setIsAuthenticated={setIsAuthenticated}
                >
                  <Contestacao />
                </MainLayout>
              </PrivateRoute>
              
              <Route exact path="/">
                <Redirect to={isAuthenticated ? "/editor-templates" : "/login"} />
              </Route>
            </Switch>
          </div>
        </Router>
      </ThemeProvider>
    </ApiKeyProvider>
  );
}

export default App; 